



























import { Vue, Component } from 'vue-property-decorator';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { NotifyMessageTestService } from '../../biz/remote/NotifyMessageTestService';
import { MessageDialog } from '../../utils/MessageDialog';
import { Session } from '../../utils/Session';

@Component({ components: { CommonDialog } })
export default class NotifyMessageDialog extends Vue {
  user_id = '';
  isLineUser = false;

  async getIsLineUser(user_id: string) {
    const biz = new NotifyMessageTestService();
    const response = await biz.isLineSettingUser(user_id);
    return response.data;
  }

  async messageSend(message: string) {
    const biz = new NotifyMessageTestService();
    await biz.sendLineMessage(message, Session.getSessionUserId());
    await MessageDialog.info(message);
  }

  /**
   * 表示
   */
  public async show(user_id: string) {
    this.user_id = user_id;
    this.isLineUser = await this.getIsLineUser(user_id);
    const dialog = this.$refs['NotifyMessageDialog'] as CommonDialog;
    dialog.show();
  }

  /**
   * 隠す
   */
  hide() {
    const dialog = this.$refs['NotifyMessageDialog'] as CommonDialog;
    dialog.hide();
  }
}
